module.exports = "/_next/static/images/Destinations@2x-1e6b9f93d411637fac56789d039f8345.webp";